// Right after a fresh cross-page navigation, an element can still measure with a zero
// rect for a while (layout/CSS hasn't settled yet) — scrollIntoView is a no-op against a
// zero-sized box. Wait until it actually has size before scrolling, instead of guessing
// how many frames to wait.
export const scrollIntoViewWhenReady = (
  el: HTMLElement | null,
  options: ScrollIntoViewOptions
): (() => void) => {
  if (!el) {
    return () => {}
  }

  const tryScroll = (): boolean => {
    const { width, height } = el.getBoundingClientRect()
    if (width === 0 && height === 0) {
      return false
    }
    el.scrollIntoView(options)
    return true
  }

  if (tryScroll()) {
    return () => {}
  }

  const observer = new ResizeObserver(() => {
    if (tryScroll()) {
      observer.disconnect()
    }
  })
  observer.observe(el)
  return () => observer.disconnect()
}
